var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_4196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.6471V16H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53676 0L10.7897 6.03333L19.0088 0H21.6471V2.06667L13.5294 8.03333L21.6471 13.9667V16H18.9412L10.8235 10.0333L2.73971 16H0V14L8.08382 8.06667L0 2.13333V0H2.53676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3412 9.36667L21.6471 14.6667V16L12.4809 9.36667H14.3412ZM8.11765 10.0333L8.32059 11.2L1.82647 16H0L8.11765 10.0333ZM21.6471 0V0.1L13.225 6.36667L13.2926 4.9L19.9559 0H21.6471ZM0 0L8.08382 5.86667H6.05441L0 1.4V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15147 0V16H13.5632V0H8.15147ZM0 5.33333V10.6667H21.6471V5.33333H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.43333V9.63333H21.6471V6.43333H0ZM9.23382 0V16H12.4809V0H9.23382Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_4196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6471,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.6ead03481f83f3ea829bb32cc31ab975.svg";
export { ForwardRef as ReactComponent };